import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ClickKeydownDirective } from './click-keydown.directive';

@NgModule({
  imports: [CommonModule],
  exports: [ClickKeydownDirective],
  declarations: [ClickKeydownDirective],
})
export class ClickKeydownModule {}
